import { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import DetalleEjercicio from './components/rutinas/DetalleEjercicio';
import TerminosYCondiciones from './components/legal/TerminosYCondiciones';
import PoliticaDePrivacidad from './components/legal/PoliticaDePrivacidad';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import HomePage from './components/HomePage';
import AppLandingPage from './components/app/AppLandingPage';
import { datosEjercicios } from './data/exercisesData';

function App() {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(150);
  const [startTyping, setStartTyping] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setStartTyping(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  // Efecto de máquina de escribir
  useEffect(() => {
    if (!startTyping) return;

    const toRotate = ["Asesoría", "Rutinas", "Nutrición"];
    const period = 2000;

    const tick = () => {
      const i = loopNum % toRotate.length;
      const fullText = toRotate[i];
      const updatedText = isDeleting
        ? fullText.substring(0, text.length - 1)
        : fullText.substring(0, text.length + 1);

      setText(updatedText);

      if (isDeleting) {
        setDelta(prevDelta => prevDelta / 2);
      }

      if (!isDeleting && updatedText === fullText) {
        setIsDeleting(true);
        setDelta(700);
      } else if (isDeleting && updatedText === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
        setDelta(150);
      }
    };

    const ticker = setInterval(() => {
      tick();
    }, delta);

    return () => clearInterval(ticker);
  }, [text, delta, isDeleting, loopNum, startTyping]);


  return (
    <>
      <ScrollToTop />
      <ScrollToTopButton />

      <Routes>
        <Route
          path="/"
          element={
            <HomePage
              typewriterText={text}
              loopNum={loopNum}
              toRotate={["Asesoría", "Rutinas", "Nutrición"]}
            />
          }
        />

        <Route path="/terminos-y-condiciones" element={<TerminosYCondiciones />} />
        <Route path="/politica-de-privacidad" element={<PoliticaDePrivacidad />} />
        <Route path="/descargar-app" element={<AppLandingPage />} />

        {/* Esta ruta debe ir al final porque captura cualquier ruta dinámica */}
        <Route
          path="/:grupo"
          element={<DetalleEjercicio
            datosEjercicios={datosEjercicios}
          />}
        />
      </Routes>
    </>
  );
}

export default App;
